import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function PageHeading(props) {
  const {
    classes,
    heading,
    isSubheading,
  } = props;

  return (
    <Typography
      variant={isSubheading ? 'h3' : 'h2'}
      component={isSubheading ? 'h2' : 'h1'}
      className={isSubheading ? classes.subHeading : classes.heading}
    >
      {heading}
    </Typography>
  );
}

PageHeading.propTypes = {
  classes: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  isSubheading: PropTypes.bool,
};

PageHeading.defaultProps = {
  isSubheading: false,
}

export default withStyles(styles)(PageHeading);
